import { ZapCard, ZapCardProps } from '../ZapCard';
import { Colors, ColorValue } from '../../../theme';

import styles from './ZapCardSection.module.scss';

type Items = Omit<ZapCardProps, 'color'> & {
  color?: ColorValue;
  key: string;
};

export type Props = {
  /**
   * Defines the contents of each ZapCard.
   */
  items: Items[];
  layout?: 'auto' | 'card' | 'mega';
};

/**
 * Displays up to three ZapCards together in a section.
 */
export const ZapCardSection = ({ items, layout = 'card' }: Props) => {
  if (items.length > 3 && layout !== 'auto') {
    console.error('Max 3 items are allowed in ZapCardSection component');
  }
  const maxItems = layout === 'auto' ? items.length : 3;
  return (
    <div className={styles.root} data-zds>
      <div className={styles.container} data-layout={layout} data-zds>
        {items
          ?.slice(0, maxItems)
          ?.map(({ color = Colors.PrimeWhite, href, ...rest }) => (
            <ZapCard {...rest} color={color} href={href} layout={layout} />
          ))}
      </div>
    </div>
  );
};
